import Header from '../../lib/Header';

import getServerSideProps from './getServerSideProps.server';

export default Header;
export { getServerSideProps };
